module.exports = __webpack_public_path__ + "assets/non_residential_2.1d6d3ddf.svg";